import { setElementInnerText } from '../ui_utils/DomUtils.ts';
import FaviconOrange from '@static/images/favicon_orange.png';
export class UIBrowserTabController {
    static resetTabTitleAndFavIcon() {
        setElementInnerText(this.pageTitle, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: this.defaultTitle
            }
        });
        this.favicon.href = this.defaultFavIcon;
    }
    static blinkTab(text) {
        setElementInnerText(this.pageTitle, text);
        this.favicon.href = FaviconOrange;
        setTimeout(()=>this.resetTabTitleAndFavIcon(), 1000);
    }
}
UIBrowserTabController.pageTitle = document.getElementById('browser_tab');
UIBrowserTabController.favicon = document.getElementById('favicon');
UIBrowserTabController.defaultTitle = UIBrowserTabController.pageTitle.innerHTML;
UIBrowserTabController.defaultFavIcon = UIBrowserTabController.favicon.href;
